import {
  useFeatureFlags,
  useFeatureFlagsProviderContext,
} from '@brightdrop/feature-flags-client';

import { LOCALIZATION_FEATURE_FLAG } from '~/common/models/featureFlags.model';

export type LocalizationFeatureFlagState = {
  isUserContextIdentified: boolean;
  isEnabled: boolean;
};

/** Reads the localization feature flag only after the user context is identified. */
export const useLocalizationFeatureFlag = (): LocalizationFeatureFlagState => {
  const { getFlag } = useFeatureFlags();
  const { isUserContextIdentified } = useFeatureFlagsProviderContext();

  return {
    isUserContextIdentified,
    isEnabled:
      isUserContextIdentified && Boolean(getFlag(LOCALIZATION_FEATURE_FLAG)),
  };
};
